<template>
  <AgGridWrapper
    v-if="columns"
    ref="agGrid"
    :options="gridOptions"
    class="fit"
    :infinite-scroll-request="infiniteScrollRequest"
    :update-rows-count="updateRowsCount"
    :visible-columns="visibleColumns"
    title="Articles"
    has-custom-column-filter
    handle-update-on-parent
    handle-column-visibility-on-parent
    @toggle-column-visibility="toggleColumnVisibility"
  >
    <template #footerActions>
      <div class="row fit q-pr-md q-pb-md justify-end">Total Rows: {{ totalRows }}</div>
    </template>
  </AgGridWrapper>
  <div v-else class="loading flex justify-center items-center fit">
    <q-spinner color="primary" size="2.5em" />
  </div>
</template>

<script>
import * as apiTo from '../api'
import { gridOptions } from './gridOptions'
// Components
import AgGridWrapper from '@components/ag-grid-helpers/AgGridWrapper'

export default {
  components: {
    AgGridWrapper
  },

  mixins: [gridOptions],

  data: () => ({
    columns: null,
    totalRows: null,
    selectedMapperCols: null,
    allMappedCols: {}
  }),

  computed: {
    visibleColumns() {
      if (!this.columns) return
      return this.columns.filter(col => col.preselected === true).map(col => col.slug)
    }
  },

  created() {
    this.$emit('refresh-stats')
    apiTo.getColumns().then(({ data }) => {
      this.selectedMapperCols = this.getMappedSelectedColumns(data.result)
      this.columns = data.result
    })
  },

  methods: {
    getMappedSelectedColumns(cols) {
      return cols.reduce((acc, curr) => {
        this.allMappedCols[curr.slug] = curr.name // set all columns
        if (curr.preselected) {
          acc[curr.slug] = curr.name
        }
        return acc
      }, {})
    },

    infiniteScrollRequest(request) {
      return apiTo.getRows({
        ...request,
        selectedMapperCols: this.selectedMapperCols
      })
    },

    updateRowsCount(rowsCount) {
      this.totalRows = rowsCount
    },

    toggleColumnVisibility({ toggledColumn, toggle }) {
      if (toggle) {
        this.$set(this.selectedMapperCols, toggledColumn, this.allMappedCols[toggledColumn])
      } else {
        delete this.selectedMapperCols[toggledColumn]
      }
      this.$refs.agGrid.purgeServerSideCache()
      this.$refs.agGrid.toggleVisibleColumn(toggledColumn, toggle)
    },

    deleteArticle({ data }) {
      apiTo.deleteArticle(data.id).then(() => {
        this.$refs.agGrid.purgeServerSideCache()
        this.$emit('refresh-stats')
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.ag-grid-wrapper-card {
  display grid
  grid-template-rows 50px 2px 1fr 35px
}

>>> .ag-theme-material {
  height 100%
}

>>> .table-content {
  padding 0 40px
}
</style>
